import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../login/login.css";
import { useDispatch, useSelector } from "react-redux";
import { LOGIN } from "app/redux/actions";
import { PATH } from "../../../config";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Loading from "app/components/MatxLoading";

export default function Login() {
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const [refereshedHours, setRefereshedHours] = useState();
  const [refereshedMinutes, setRefereshedMinutes] = useState();
  const userState = useSelector((state) => state.user);
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
   
    if (userState.user && userState.user.token) {
     
      navigate(PATH.DASHBOARD, { replace: true });
    }
  }, [userState, navigate]); 

  const moveToNext = () => {
    toast.success("Login Successful!");
    navigate(state?.from || PATH.DASHBOARD, { replace: true });
  };
  const moveToFail = (message) => {
    toast.error(message);
  };
  
  const loginValidationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/\d/, "Password must contain at least one number")
      .matches(
        /[@$!%*?&]/,
        "Password must contain at least one special character"
      ),
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      setRefereshedHours(hours);
      setRefereshedMinutes(formattedMinutes);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const now = new Date();
  const shortMonthName = now.toLocaleString("default", { month: "short" });
  let dayOfMonth = now.getDate();
  const handleForgotPassword = () => {
    navigate(PATH.FORGOTPASSWORD);
  }

  if (userState.user && userState.user.token) {
    return <Loading />;
  }

  return (
    <div className="main">
      <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={loginValidationSchema}
        onSubmit={(values) => {
          const trimmedValues = {
            ...values,
            email: values.email.trim(),
          };
          dispatch(LOGIN(trimmedValues, moveToNext, moveToFail));
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <div style={{ display: "flex" }}>
              <div className="login-img">
                <div className="parent-img">
                  <img
                    className="bg-login"
                    src="/assets/images/login-bg.svg"
                    alt=""
                  />
                  <img
                    className="logo"
                    src="/assets/images/technodevs.svg"
                    alt=""
                  />
                  <p className="login-info" style={{ lineHeight: "40px" }}>
                    Track your work & <br />
                    own your growth
                  </p>
                  <p className="login-info2" style={{ width: "80%" }}>
                    Log in to monitor your working hours, apply for leave, and
                    stay updated on your progress. TechnoDevs gives you the
                    tools to stay in control of your journey.
                  </p>
                  <p className="login-time">
                    {refereshedHours}
                    <span className="separator">:</span>
                    {refereshedMinutes}
                  </p>
                  <p className="login-date">{dayOfMonth}</p>
                  <p className="login-month">{shortMonthName}</p>
                  <p className="login-day">
                    {new Date().toLocaleString("en-us", { weekday: "long" })}
                  </p>
                </div>
              </div>
              <div className="td-title" style={{ lineHeight: "35px" }}>
                <i style={{ fontSize: "36px", color: "#757878" }}>
                  Welcome to <br />
                  <span style={{ color: "#0072BC", fontWeight: "bold" }}>
                    TechnoDevs
                  </span>{" "}
                  Family
                </i>
                <div>
                  <div
                    className="login-inp"
                    style={{ lineHeight: "1px", marginTop: "45px" }}
                  >
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "16px",
                        color: "#757878",
                      }}
                    >
                      Email
                    </p>
                    <Field
                      className="email-inp"
                      style={{
                        border: "1px solid #D9D9D9",
                        borderRadius: "10px",
                        letterSpacing: "1px",
                        paddingLeft: "20px",
                        fontWeight: "bold",
                      }}
                      type="email"
                      name="email"
                      placeholder="name@technodevs.com"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      style={{
                        marginTop: "1rem",
                        color: "red",
                        fontSize: "15px",
                      }}
                    />
                  </div>
                  <div
                    className="login-inp"
                    style={{ lineHeight: "1px", marginTop: "30px" }}
                  >
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "16px",
                        color: "#757878",
                      }}
                    >
                      Password
                    </p>
                    <div
                      className="password-input"
                      style={{
                        display: "flex",
                        backgroundColor: "white",
                        border: "1px solid #D9D9D9",
                        borderRadius: "10px",
                      }}
                    >
                      <Field
                        className="pass-inp"
                        name="password"
                        style={{
                          border: "0px",
                          outline: "none",
                          letterSpacing: "1px",
                          paddingLeft: "20px",
                          borderRadius: "10px",
                          fontWeight: "bold",
                        }}
                        type={visible ? "text" : "password"}
                        placeholder="*****************"
                      />
                      <div
                        style={{ marginTop: "13px", cursor: "pointer" }}
                        onClick={() => setVisible(!visible)}
                      >
                        {visible ? (
                          <img
                            src="/assets/images/showpassword.svg"
                            alt="Show password"
                          />
                        ) : (
                          <img
                            src="/assets/images/eye-slash-fill.svg"
                            alt="Hide password"
                          />
                        )}
                      </div>
                    </div>
                    <ErrorMessage
                      name="password"
                      component="div"
                      style={{
                        marginTop: "1rem",
                        color: "red",
                        fontSize: "15px",
                      }}
                    />
                  </div>
                </div>
                {userState.loginLoading === true ? (
                  <Loading />
                ) : (
                  <div className="login-btn">
                    <button type="submit">
                      {userState.loginLoading ? "Logging in..." : "Login"}
                    </button>
                  </div>
                )}

                <div style={{ marginTop: "25px" }}>
                  <u
                    style={{
                      fontSize: "16px",
                      color: "#757878",
                      cursor: "pointer",
                    }}
                    onClick={handleForgotPassword}
                  >
                    Forgot Password?
                  </u>
                </div>
                <div className="td-founding" style={{ color: "#757878" }}>
                  <i>Founding year-2014</i>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}